import type { LexData } from "./types";

const now = Date.now();
const day = 24 * 60 * 60 * 1000;

export const demoData: LexData = {
  viewer: {
    id: "user-1",
    name: "Elena Marceau",
    email: "elena.marceau@marceau-law.eu",
    firmId: "firm-1",
    role: "Full Member Representative",
    memberCategory: "full_member_representative",
    roles: [],
    representativeType: "principal",
    active: true,
    avatarUrl: null,
    emailPushSubscriptions: ["governance_votes", "proposals", "network_actions", "meetings_events", "member_input_requests"],
    createdAt: now - 80 * day,
    updatedAt: now - day,
  },
  viewerFirm: {
    id: "firm-1",
    name: "Marceau & Ionescu",
    jurisdiction: "Luxembourg",
    membershipCategory: "Full Member",
    lawyerCount: 12,
    independenceStatement: "Independent boutique focused on cross-border commercial and regulatory work.",
    status: "active",
    affiliationGroupId: null,
    logoUrl: null,
    avatarUrl: null,
    admittedAt: now - 70 * day,
    acceptsCooperationRequests: true,
    cooperationInterests: ["ask_view", "local_counsel", "co_counsel", "jurisdiction_assistance"],
    languages: ["English", "French", "Luxembourgish"],
    preferredContactMode: "Expertise exchange request first, then direct call when professionally appropriate.",
    responseTimeIndicator: "Usually within 1 business day",
    conflictCheckInstructions: "Send a non-confidential summary first. Names can be exchanged only when professionally appropriate.",
    createdAt: now - 80 * day,
    updatedAt: now - day,
  },
  firms: [
    {
      id: "firm-1",
      name: "Marceau & Ionescu",
      jurisdiction: "Luxembourg",
      membershipCategory: "Full Member",
      lawyerCount: 12,
      independenceStatement: "Independent boutique focused on cross-border commercial and regulatory work.",
      status: "active",
      affiliationGroupId: null,
      logoUrl: null,
      avatarUrl: null,
      admittedAt: now - 70 * day,
      acceptsCooperationRequests: true,
      cooperationInterests: ["ask_view", "local_counsel", "co_counsel", "jurisdiction_assistance"],
      languages: ["English", "French", "Luxembourgish"],
      preferredContactMode: "Expertise exchange request first, then direct call when professionally appropriate.",
      responseTimeIndicator: "Usually within 1 business day",
      conflictCheckInstructions: "Send a non-confidential summary first. Names can be exchanged only when professionally appropriate.",
      createdAt: now - 80 * day,
      updatedAt: now - day,
    },
    {
      id: "firm-2",
      name: "Van Dijk Legal",
      jurisdiction: "Netherlands",
      membershipCategory: "Full Member",
      lawyerCount: 9,
      independenceStatement: "Independent Amsterdam practice advising founder-led technology companies.",
      status: "active",
      affiliationGroupId: null,
      logoUrl: null,
      avatarUrl: null,
      admittedAt: now - 69 * day,
      acceptsCooperationRequests: true,
      cooperationInterests: ["ask_view", "local_counsel", "matter_referral", "expert_input"],
      languages: ["English", "Dutch"],
      preferredContactMode: "Platform request, then call when professionally appropriate.",
      responseTimeIndicator: "Usually within 2 business days",
      conflictCheckInstructions: "Avoid client names in initial requests.",
      createdAt: now - 80 * day,
      updatedAt: now - day,
    },
    {
      id: "firm-3",
      name: "Rossi Avvocati",
      jurisdiction: "Italy",
      membershipCategory: "Full Member",
      lawyerCount: 15,
      independenceStatement: "Independent Milan disputes and regulatory boutique.",
      status: "active",
      affiliationGroupId: "aff-1",
      logoUrl: null,
      avatarUrl: null,
      admittedAt: now - 60 * day,
      acceptsCooperationRequests: true,
      cooperationInterests: ["co_counsel", "matter_referral", "jurisdiction_assistance"],
      languages: ["Italian", "English"],
      preferredContactMode: "Structured request with deadline.",
      responseTimeIndicator: "Usually within 1 business day",
      conflictCheckInstructions: "Use anonymised parties until disclosure is appropriate.",
      createdAt: now - 75 * day,
      updatedAt: now - day,
    },
    {
      id: "firm-4",
      name: "Keller Rechtsanwalte",
      jurisdiction: "Germany",
      membershipCategory: "Associate Member",
      lawyerCount: 7,
      independenceStatement: "Specialist German employment and commercial law practice.",
      status: "active",
      affiliationGroupId: null,
      logoUrl: null,
      avatarUrl: null,
      admittedAt: now - 58 * day,
      acceptsCooperationRequests: true,
      cooperationInterests: ["ask_view", "expert_input", "working_group_cooperation"],
      languages: ["German", "English"],
      preferredContactMode: "Platform request.",
      responseTimeIndicator: "Usually within 3 business days",
      conflictCheckInstructions: "General issue description only at the first step.",
      createdAt: now - 70 * day,
      updatedAt: now - day,
    },
    {
      id: "firm-5",
      name: "Aubert Droit Public",
      jurisdiction: "France",
      membershipCategory: "Full Member",
      lawyerCount: 6,
      independenceStatement: "Paris public law practice with EU regulatory focus.",
      status: "active",
      affiliationGroupId: null,
      logoUrl: null,
      avatarUrl: null,
      admittedAt: now - 45 * day,
      acceptsCooperationRequests: true,
      cooperationInterests: ["ask_view", "local_counsel", "working_group_cooperation"],
      languages: ["French", "English"],
      preferredContactMode: "Request first, message thread second.",
      responseTimeIndicator: "Usually within 1 business day",
      conflictCheckInstructions: "No confidential administrative file details in initial requests.",
      createdAt: now - 62 * day,
      updatedAt: now - day,
    },
    {
      id: "firm-6",
      name: "Nowak Legal",
      jurisdiction: "Poland",
      membershipCategory: "Full Member",
      lawyerCount: 10,
      independenceStatement: "Warsaw corporate and competition boutique.",
      status: "active",
      affiliationGroupId: null,
      logoUrl: null,
      avatarUrl: null,
      admittedAt: now - 35 * day,
      acceptsCooperationRequests: true,
      cooperationInterests: ["ask_view", "co_counsel", "jurisdiction_assistance"],
      languages: ["Polish", "English"],
      preferredContactMode: "Platform request.",
      responseTimeIndicator: "Usually within 2 business days",
      conflictCheckInstructions: "Anonymised commercial context is enough for first pass.",
      createdAt: now - 50 * day,
      updatedAt: now - day,
    },
    {
      id: "firm-7",
      name: "Santos Fiscal",
      jurisdiction: "Spain",
      membershipCategory: "Full Member",
      lawyerCount: 8,
      independenceStatement: "Madrid tax and private client boutique.",
      status: "active",
      affiliationGroupId: null,
      logoUrl: null,
      avatarUrl: null,
      admittedAt: now - 30 * day,
      acceptsCooperationRequests: true,
      cooperationInterests: ["local_counsel", "matter_referral", "jurisdiction_assistance"],
      languages: ["Spanish", "English"],
      preferredContactMode: "Platform request with deadline if urgent.",
      responseTimeIndicator: "Usually within 2 business days",
      conflictCheckInstructions: "Do not share client names in initial request.",
      createdAt: now - 44 * day,
      updatedAt: now - day,
    },
    {
      id: "firm-8",
      name: "O'Connor Legal",
      jurisdiction: "Ireland",
      membershipCategory: "Expert Contributor",
      lawyerCount: 4,
      independenceStatement: "Dublin data protection and digital regulation practice.",
      status: "active",
      affiliationGroupId: null,
      logoUrl: null,
      avatarUrl: null,
      admittedAt: now - 18 * day,
      acceptsCooperationRequests: true,
      cooperationInterests: ["ask_view", "expert_input", "working_group_cooperation"],
      languages: ["English"],
      preferredContactMode: "Expert input request.",
      responseTimeIndicator: "Usually within 2 business days",
      conflictCheckInstructions: "Technical issue only; no client identifiers.",
      createdAt: now - 35 * day,
      updatedAt: now - day,
    },
  ],
  users: [
    { id: "user-1", name: "Elena Marceau", email: "elena.marceau@marceau-law.eu", firmId: "firm-1", role: "Full Member Representative", memberCategory: "full_member_representative", roles: [], representativeType: "principal", avatarUrl: null, active: true, emailPushSubscriptions: ["governance_votes", "proposals", "network_actions", "meetings_events", "member_input_requests"], createdAt: now - 80 * day, updatedAt: now - day },
    { id: "user-2", name: "Maarten van Dijk", email: "maarten@vandijklegal.nl", firmId: "firm-2", role: "Full Member Representative", memberCategory: "full_member_representative", roles: [], representativeType: "principal", avatarUrl: null, active: true, emailPushSubscriptions: ["governance_votes", "proposals", "network_actions"], createdAt: now - 80 * day, updatedAt: now - day },
    { id: "user-3", name: "Chiara Rossi", email: "chiara@rossiavvocati.it", firmId: "firm-3", role: "Coordination Committee", memberCategory: "full_member_representative", roles: ["workspace_manager"], representativeType: "principal", avatarUrl: null, active: true, emailPushSubscriptions: ["governance_votes", "network_actions", "meetings_events"], createdAt: now - 75 * day, updatedAt: now - day },
    { id: "user-4", name: "Jonas Keller", email: "jonas@keller-law.de", firmId: "firm-4", role: "Associate Member", memberCategory: "associate_member", roles: [], representativeType: "participant", avatarUrl: null, active: true, emailPushSubscriptions: ["proposals", "meetings_events"], createdAt: now - 70 * day, updatedAt: now - day },
    { id: "user-5", name: "Claire Aubert", email: "claire@aubert-public.fr", firmId: "firm-5", role: "Governance Admin", memberCategory: "full_member_representative", roles: ["administrator"], representativeType: "principal", avatarUrl: null, active: true, emailPushSubscriptions: ["governance_votes", "proposals", "network_actions", "meetings_events", "member_input_requests"], createdAt: now - 62 * day, updatedAt: now - day },
    { id: "user-6", name: "Pawel Nowak", email: "pawel@nowaklegal.pl", firmId: "firm-6", role: "Full Member Representative", memberCategory: "full_member_representative", roles: [], representativeType: "principal", avatarUrl: null, active: true, emailPushSubscriptions: ["governance_votes", "proposals", "network_actions"], createdAt: now - 50 * day, updatedAt: now - day },
  ],
  affiliationGroups: [
    {
      id: "aff-1",
      name: "Rossi Advisory Alliance",
      affiliationType: "formal alliance",
      explanation: "A documented alliance with separate ownership and independent client acceptance.",
      active: true,
      createdBy: "user-5",
      createdAt: now - 40 * day,
      updatedAt: now - 5 * day,
    },
  ],
  practiceAreas: [
    { id: "pa-1", name: "Commercial litigation", slug: "commercial-litigation", description: "Commercial disputes and enforcement.", active: true, createdBy: "user-5", createdAt: now - 60 * day, updatedAt: now - day },
    { id: "pa-2", name: "Competition", slug: "competition", description: "Competition law and merger control.", active: true, createdBy: "user-5", createdAt: now - 60 * day, updatedAt: now - day },
    { id: "pa-3", name: "Data protection", slug: "data-protection", description: "Privacy, data governance and digital rules.", active: true, createdBy: "user-5", createdAt: now - 60 * day, updatedAt: now - day },
    { id: "pa-4", name: "Employment", slug: "employment", description: "Employment and workplace matters.", active: true, createdBy: "user-5", createdAt: now - 60 * day, updatedAt: now - day },
    { id: "pa-5", name: "Public law", slug: "public-law", description: "Administrative and public procurement law.", active: true, createdBy: "user-5", createdAt: now - 60 * day, updatedAt: now - day },
    { id: "pa-6", name: "Tax", slug: "tax", description: "Tax structuring and disputes.", active: true, createdBy: "user-5", createdAt: now - 60 * day, updatedAt: now - day },
    { id: "pa-7", name: "Corporate", slug: "corporate", description: "Corporate advisory and transactions.", active: true, createdBy: "user-5", createdAt: now - 60 * day, updatedAt: now - day },
    { id: "pa-8", name: "Regulatory", slug: "regulatory", description: "Regulated industries and policy work.", active: true, createdBy: "user-5", createdAt: now - 60 * day, updatedAt: now - day },
  ],
  firmPracticeAreas: [
    { firmId: "firm-1", practiceAreaId: "pa-1", createdBy: "user-1", createdAt: now - 20 * day },
    { firmId: "firm-1", practiceAreaId: "pa-3", createdBy: "user-1", createdAt: now - 20 * day },
    { firmId: "firm-1", practiceAreaId: "pa-8", createdBy: "user-1", createdAt: now - 20 * day },
    { firmId: "firm-2", practiceAreaId: "pa-3", createdBy: "user-2", createdAt: now - 20 * day },
    { firmId: "firm-2", practiceAreaId: "pa-7", createdBy: "user-2", createdAt: now - 20 * day },
    { firmId: "firm-3", practiceAreaId: "pa-1", createdBy: "user-3", createdAt: now - 20 * day },
    { firmId: "firm-3", practiceAreaId: "pa-8", createdBy: "user-3", createdAt: now - 20 * day },
    { firmId: "firm-4", practiceAreaId: "pa-4", createdBy: "user-4", createdAt: now - 20 * day },
    { firmId: "firm-5", practiceAreaId: "pa-5", createdBy: "user-5", createdAt: now - 20 * day },
    { firmId: "firm-5", practiceAreaId: "pa-8", createdBy: "user-5", createdAt: now - 20 * day },
    { firmId: "firm-6", practiceAreaId: "pa-2", createdBy: "user-6", createdAt: now - 20 * day },
    { firmId: "firm-6", practiceAreaId: "pa-7", createdBy: "user-6", createdAt: now - 20 * day },
    { firmId: "firm-7", practiceAreaId: "pa-6", createdBy: "user-1", createdAt: now - 20 * day },
    { firmId: "firm-8", practiceAreaId: "pa-3", createdBy: "user-1", createdAt: now - 20 * day },
  ],
  userPracticeAreas: [
    { userId: "user-1", practiceAreaId: "pa-1", createdBy: "user-1", createdAt: now - 20 * day },
    { userId: "user-1", practiceAreaId: "pa-3", createdBy: "user-1", createdAt: now - 20 * day },
    { userId: "user-2", practiceAreaId: "pa-3", createdBy: "user-2", createdAt: now - 20 * day },
    { userId: "user-2", practiceAreaId: "pa-7", createdBy: "user-2", createdAt: now - 20 * day },
    { userId: "user-3", practiceAreaId: "pa-8", createdBy: "user-3", createdAt: now - 20 * day },
    { userId: "user-4", practiceAreaId: "pa-4", createdBy: "user-4", createdAt: now - 20 * day },
    { userId: "user-5", practiceAreaId: "pa-5", createdBy: "user-5", createdAt: now - 20 * day },
    { userId: "user-6", practiceAreaId: "pa-2", createdBy: "user-6", createdAt: now - 20 * day },
  ],
  jurisdictionTags: [
    { id: "jur-eu", name: "EU", active: true, createdBy: "user-1", createdAt: now - 20 * day, updatedAt: now - day },
    { id: "jur-lu", name: "Luxembourg", active: true, createdBy: "user-1", createdAt: now - 20 * day, updatedAt: now - day },
    { id: "jur-be", name: "Belgium", active: true, createdBy: "user-1", createdAt: now - 20 * day, updatedAt: now - day },
    { id: "jur-fr", name: "France", active: true, createdBy: "user-1", createdAt: now - 20 * day, updatedAt: now - day },
    { id: "jur-ch", name: "Switzerland", active: true, createdBy: "user-1", createdAt: now - 20 * day, updatedAt: now - day },
    { id: "jur-cross", name: "Cross-border", active: true, createdBy: "user-1", createdAt: now - 20 * day, updatedAt: now - day },
  ],
  discussions: [
    {
      id: "disc-welcome",
      title: "Welcome to LexMosaic",
      type: "practice_note",
      postType: "Discussion",
      body: "Welcome — you've joined a network of independent law firms built without a head office or a hierarchy: good lawyers, the right tools, and a fair way to decide together.\n\n## What holds us together\n\n1. **Know the people you refer to** — Get to know the firms closest to each jurisdiction so referrals go to someone you trust — no fees, no strings.\n2. **Build with technology** — Propose and join projects that weave technology and AI into legal practice.\n3. **Speak to Brussels with one voice** — Track the files that matter and draft joint, mandated positions together.\n\n## How we decide\n\n> LexMosaic has no board, no president, no council. Inspired by liquid democracy — and going a step further — power isn't delegated; it's exercised directly through votes.\n>\n> Our votes are a mosaic: not a blunt yes or no, but strong support, support with reservations, maybe, why not, or probably not. Each firm's voice is gently weighted by its participation — earned in the open, and always capped so no one dominates.\n\nSo introduce yourself, find firms near the jurisdictions you work across, float an ambitious idea, and weigh in on the next position headed for Brussels.\n\n**Welcome to LexMosaic. Let's see what we can build together.**",
      status: "open",
      createdByUserId: "user-5",
      createdByFirmId: "firm-5",
      practiceAreaIds: [],
      topicTags: [],
      jurisdictionTags: ["EU"],
      confidentialityLevel: "Network-wide",
      workflowStatus: "Open",
      actionLabels: ["No action required"],
      visibility: "network",
      pinned: true,
      createdAt: now - 30 * day,
      updatedAt: now - 30 * day,
      lastActivityAt: now - 30 * day,
    },
    {
      id: "disc-1",
      title: "How are members handling consumer green claims guidance?",
      type: "question",
      postType: "Question",
      body: "We would value member views on recent green claims guidance in consumer-facing sectors.",
      status: "open",
      createdByUserId: "user-2",
      createdByFirmId: "firm-2",
      practiceAreaIds: ["pa-3", "pa-8"],
      topicTags: ["Consumer law", "Data protection", "Platform regulation"],
      jurisdictionTags: ["EU", "Netherlands"],
      confidentialityLevel: "Network-wide",
      workflowStatus: "Input requested",
      actionLabels: ["Input requested", "Review requested"],
      relatedLinks: [{ kind: "project", id: "lobby-1", label: "Digital Fairness joint position" }],
      deadline: now + 6 * day,
      visibility: "network",
      linkedLegislationFileId: null,
      linkedGovernanceProposalId: null,
      createdAt: now - 2 * day,
      updatedAt: now - day,
      lastActivityAt: now - 3 * 60 * 60 * 1000,
    },
    {
      id: "disc-2",
      title: "Draft note on dawn raid readiness for smaller teams",
      type: "practice_note",
      postType: "Resource",
      body: "A practical note for lean independent firms preparing first-response protocols.",
      status: "drafting",
      createdByUserId: "user-6",
      createdByFirmId: "firm-6",
      practiceAreaIds: ["pa-2", "pa-7"],
      topicTags: ["Competition", "Corporate governance", "Knowledge sharing"],
      jurisdictionTags: ["EU", "Poland"],
      confidentialityLevel: "Full Members only",
      workflowStatus: "Under review",
      actionLabels: ["Review requested"],
      relatedLinks: [{ kind: "project", id: "knowledge-dawn-raid", label: "Dawn raid readiness note" }],
      deadline: now + 10 * day,
      visibility: "members",
      linkedLegislationFileId: null,
      linkedGovernanceProposalId: null,
      createdAt: now - 4 * day,
      updatedAt: now - day,
      lastActivityAt: now - 6 * 60 * 60 * 1000,
    },
    {
      id: "disc-3",
      title: "Proposal: rotate drafting leads for joint positions",
      type: "governance_proposal",
      postType: "Proposal",
      body: "A light governance proposal to rotate drafting leads when several firms join a position.",
      status: "open",
      createdByUserId: "user-3",
      createdByFirmId: "firm-3",
      practiceAreaIds: ["pa-8"],
      topicTags: ["EU affairs", "Member governance", "Working group"],
      jurisdictionTags: ["EU", "Cross-border"],
      confidentialityLevel: "Network-wide",
      workflowStatus: "Voting open",
      actionLabels: ["Vote required", "Decision needed"],
      relatedLinks: [{ kind: "proposal", id: "prop-1", label: "Drafting lead rotation" }, { kind: "vote", id: "prop-1", label: "Final vote" }],
      deadline: now + 7 * day,
      visibility: "members",
      linkedLegislationFileId: null,
      linkedGovernanceProposalId: "prop-1",
      createdAt: now - 6 * day,
      updatedAt: now - day,
      lastActivityAt: now - 12 * 60 * 60 * 1000,
    },
    {
      id: "disc-4",
      title: "AI regulation working group charter",
      type: "governance_proposal",
      postType: "Proposal",
      body: "Draft charter for a member working group on AI regulation implementation.",
      status: "drafting",
      createdByUserId: "user-1",
      createdByFirmId: "firm-1",
      practiceAreaIds: ["pa-3", "pa-8"],
      topicTags: ["AI regulation", "Working group", "Member governance"],
      jurisdictionTags: ["EU", "Cross-border"],
      confidentialityLevel: "Full Members only",
      workflowStatus: "Draft",
      actionLabels: ["No action required"],
      relatedLinks: [],
      deadline: null,
      visibility: "members",
      linkedLegislationFileId: null,
      linkedGovernanceProposalId: null,
      createdAt: now - 5 * day,
      updatedAt: now - 5 * 60 * 60 * 1000,
      lastActivityAt: now - 5 * 60 * 60 * 1000,
    },
    {
      id: "disc-5",
      title: "GDPR transfer practice",
      type: "question",
      postType: "Question",
      body: "Draft question on current member practice for international transfer assessments.",
      status: "drafting",
      createdByUserId: "user-1",
      createdByFirmId: "firm-1",
      practiceAreaIds: ["pa-3"],
      topicTags: ["Data protection", "Legal operations"],
      jurisdictionTags: ["EU", "Luxembourg"],
      confidentialityLevel: "Network-wide",
      workflowStatus: "Draft",
      actionLabels: ["No action required"],
      relatedLinks: [],
      deadline: null,
      visibility: "network",
      linkedLegislationFileId: null,
      linkedGovernanceProposalId: null,
      createdAt: now - 3 * day,
      updatedAt: now - 90 * 60 * 1000,
      lastActivityAt: now - 90 * 60 * 1000,
    },
  ],
  contributions: [
    { id: "cont-1", discussionId: "disc-1", type: "comment", body: "We can share our approach to substantiation files.", createdByUserId: "user-1", createdByFirmId: "firm-1", createdAt: now - 2 * 60 * 60 * 1000, updatedAt: now - 2 * 60 * 60 * 1000 },
    { id: "cont-2", discussionId: "disc-2", type: "note", body: "Useful checklist. We should add a short call tree section.", createdByUserId: "user-3", createdByFirmId: "firm-3", createdAt: now - 7 * 60 * 60 * 1000, updatedAt: now - 7 * 60 * 60 * 1000 },
  ],
  attachments: [
    { id: "att-1", entityType: "discussion", entityId: "disc-2", filename: "dawn-raid-readiness-checklist.pdf", contentType: "application/pdf", size: 184_320, uploadedByUserId: "user-3", url: null, createdAt: now - 6 * 60 * 60 * 1000 },
  ],
  proposals: [
    {
      id: "prop-1",
      discussionId: "disc-3",
      category: "ordinary",
      proposalText: "Drafting leads should rotate across participating full members unless the drafting group agrees otherwise.",
      consolidatedText: null,
      status: "final_vote",
      thresholdType: "simple",
      proposerFirmId: "firm-3",
      coSponsorFirmIds: ["firm-1"],
      amendmentOpensAt: now - day,
      amendmentClosesAt: now + 3 * day,
      votingOpensAt: now - 6 * 60 * 60 * 1000,
      votingClosesAt: now + 7 * day,
      createdAt: now - 6 * day,
      updatedAt: now - day,
    },
  ],
  amendments: [
    {
      id: "amd-1",
      proposalId: "prop-1",
      amendmentNumber: 1,
      type: "replacement",
      targetSectionId: "section-1",
      targetText: "rotate across participating full members",
      proposedText: "rotate across participating full members, taking practice expertise into account",
      rationale: "Keeps rotation practical where the file is highly specialised.",
      sponsorFirmId: "firm-1",
      coSponsorFirmIds: ["firm-5"],
      status: "provisionally_admissible",
      autoRejectionReason: null,
      objectionStatus: "none",
      conflictGroupId: "section-1",
      voteResult: null,
      createdAt: now - 10 * 60 * 60 * 1000,
      updatedAt: now - 10 * 60 * 60 * 1000,
      withdrawnAt: null,
    },
  ],
  voteResultSnapshots: [],
  votes: [],
  delegations: [],
  legislationFiles: [
    {
      id: "leg-1",
      title: "EU Digital Fairness consultation",
      jurisdictionOrInstitution: "European Commission",
      initiativeName: "Digital Fairness",
      practiceAreaIds: ["pa-3", "pa-8"],
      sourceUrl: "https://commission.europa.eu/",
      status: "drafting",
      stage: "Consultation open",
      deadline: now + 14 * day,
      ownerFirmId: "firm-5",
      summary: "Members are preparing a short joint position on transparency obligations for digital services.",
      createdByUserId: "user-5",
      createdAt: now - 8 * day,
      updatedAt: now - day,
    },
  ],
  legislativeSources: [],
  legislativeSourceDefinitions: [],
  legislativeFeedItems: [],
  legislativeFeedSnapshots: [],
  legislativeFeedEvents: [],
  legislativeReviewQueue: [],
  legislativeMemberPreference: null,
  lobbyingProjects: [
    {
      id: "lobby-1",
      title: "Digital Fairness joint position",
      legislationFileId: "leg-1",
      objective: "Prepare a measured member position on proportionate obligations for smaller advisers and clients.",
      targetInstitutions: ["European Commission"],
      ownerFirmId: "firm-5",
      status: "drafting",
      mandateStatus: "approved",
      transparencyStatus: "pending",
      deadline: now + 14 * day,
      helpWanted: true,
      neededExpertise: ["French administrative law", "EU competition", "Consumer protection"],
      mandateRationale: "Coordinate a measured, proportionate network position ahead of the Commission consultation.",
      mandateReviewNote: "Scope limited to a written submission and one stakeholder meeting.",
      mandateRequestedByUserId: "user-5",
      mandateDecidedByUserId: "user-3",
      mandateRequestedAt: now - 6 * day,
      mandateDecidedAt: now - 5 * day,
      createdAt: now - 8 * day,
      updatedAt: now - day,
    },
  ],
  lobbyingProjectParticipants: [
    { id: "lpp-1", projectId: "lobby-1", firmId: "firm-1", userId: "user-1", role: "jurisdiction_lead", jurisdiction: "France", note: "Can cover the French administrative-law angle.", createdAt: now - 5 * day, updatedAt: now - 5 * day },
    { id: "lpp-2", projectId: "lobby-1", firmId: "firm-3", userId: "user-3", role: "reviewer", jurisdiction: "Italy", note: "Happy to review drafts for proportionality.", createdAt: now - 4 * day, updatedAt: now - 4 * day },
  ],
  lobbyingProjectEndorsements: [
    { id: "lpe-1", projectId: "lobby-1", firmId: "firm-2", userId: "user-2", note: "Supports a proportionate position.", createdAt: now - 3 * day },
    { id: "lpe-2", projectId: "lobby-1", firmId: "firm-6", userId: "user-6", note: "", createdAt: now - 2 * day },
  ],
  lobbyingProjectMessages: [
    { id: "lpm-1", projectId: "lobby-1", authorUserId: "user-1", authorFirmId: "firm-1", body: "Suggest we anchor the submission on proportionality for smaller advisers and avoid sector-specific carve-outs.", tag: "drafting note", visibility: "members", createdAt: now - 4 * day, updatedAt: now - 4 * day },
  ],
  lobbyingProjectDocuments: [
    { id: "lpd-1", projectId: "lobby-1", title: "Joint position — working draft", documentType: "Position draft", fileUrlOrExternalLink: "https://example.org/lexmosaic/digital-fairness-draft", version: "v0.3", status: "draft", uploadedByUserId: "user-5", linkedProposalId: null, createdAt: now - 3 * day, updatedAt: now - day },
  ],
  lobbyingProjectCommunications: [
    { id: "lpc-1", projectId: "lobby-1", communicationType: "Written submission", communicationDate: now - day, externalRecipientType: "European Commission", externalRecipientName: "DG JUST consultation", sentOrAttendedByUserId: "user-5", sentOrAttendedByFirmId: "firm-5", actingCapacity: "On behalf of the network under an approved mandate", summary: "Filed the network's written response to the consultation.", documentId: "lpd-1", mandateId: null, transparencyNote: "Logged for the transparency register.", followUpRequired: false, createdAt: now - day },
  ],
  cooperationEvents: [
    {
      id: "coop-1",
      cooperationCode: "COOP-2026-Q2-001",
      initiatingFirmId: "firm-2",
      receivingFirmId: "firm-1",
      quarter: "2026-Q2",
      level: 2,
      practiceAreaId: "pa-3",
      jurisdictionFrom: "Netherlands",
      jurisdictionTo: "Luxembourg",
      cooperationType: "Standard cooperation",
      consentConfirmed: true,
      conflictStatus: "pending",
      eventStatus: "pending confirmation",
      handlingConfirmation: "Initial availability confirmed.",
      knowledgeDebriefExpected: true,
      knowledgeDebriefSubmitted: false,
      levelConfirmed: true,
      proposedLowerLevel: null,
      reviewRequested: false,
      closedAt: null,
      createdAt: now - 3 * day,
      updatedAt: now - day,
    },
  ],
  cooperationRequests: [
    {
      id: "coop-req-1",
      requestType: "local_counsel",
      title: "Luxembourg view on digital service notice timing",
      shortSummary: "A Dutch member asks for a non-confidential local view on procedural timing for a digital services matter. No client identity or privileged facts have been shared.",
      jurisdictionTags: ["Luxembourg", "Netherlands"],
      practiceAreaIds: ["pa-3", "pa-8"],
      urgency: "time_sensitive",
      confidentialityLevel: "requester_and_target_only",
      requesterFirmId: "firm-2",
      requesterUserId: "user-2",
      targetFirmId: "firm-1",
      targetUserId: "user-1",
      relatedMemberId: "user-1",
      status: "awaiting_conflict_check",
      conflictCheckRequired: true,
      clientDisclosed: false,
      clientNameEncryptedOrNull: null,
      confidentialDetailsAdded: false,
      allowFirmRouting: true,
      deadline: now + 4 * day,
      invitedUserIds: [],
      createdAt: now - 2 * day,
      updatedAt: now - 6 * 60 * 60 * 1000,
      expiresAt: now + 4 * day,
      closedAt: null,
      metadataJson: "{\"governanceImpact\":false}",
    },
    {
      id: "coop-req-2",
      requestType: "ask_view",
      title: "French public law angle on platform procurement",
      shortSummary: "Marceau & Ionescu requests a non-confidential view on whether a planned public procurement discussion should be monitored by the network.",
      jurisdictionTags: ["France", "EU"],
      practiceAreaIds: ["pa-5", "pa-8"],
      urgency: "normal",
      confidentialityLevel: "requester_and_target_only",
      requesterFirmId: "firm-1",
      requesterUserId: "user-1",
      targetFirmId: "firm-5",
      targetUserId: "user-5",
      relatedMemberId: "user-5",
      status: "accepted",
      conflictCheckRequired: false,
      clientDisclosed: false,
      clientNameEncryptedOrNull: null,
      confidentialDetailsAdded: false,
      allowFirmRouting: true,
      deadline: now + 7 * day,
      invitedUserIds: [],
      createdAt: now - 3 * day,
      updatedAt: now - day,
      expiresAt: now + 7 * day,
      closedAt: null,
      metadataJson: "{\"governanceImpact\":false}",
    },
    {
      id: "coop-req-3",
      requestType: "matter_referral",
      title: "Spanish tax counsel for cross-border structuring question",
      shortSummary: "A potential need for Spanish tax input has been identified. The request remains anonymised until disclosure is appropriate.",
      jurisdictionTags: ["Spain", "Cross-border"],
      practiceAreaIds: ["pa-6"],
      urgency: "urgent",
      confidentialityLevel: "requester_and_target_only",
      requesterFirmId: "firm-1",
      requesterUserId: "user-1",
      targetFirmId: "firm-7",
      targetUserId: null,
      relatedMemberId: null,
      status: "conflict_check_requested",
      conflictCheckRequired: true,
      clientDisclosed: false,
      clientNameEncryptedOrNull: null,
      confidentialDetailsAdded: false,
      allowFirmRouting: true,
      deadline: now + 2 * day,
      invitedUserIds: [],
      createdAt: now - day,
      updatedAt: now - 2 * 60 * 60 * 1000,
      expiresAt: now + 2 * day,
      closedAt: null,
      metadataJson: "{\"governanceImpact\":false}",
    },
  ],
  cooperationMessages: [
    {
      id: "coop-msg-1",
      cooperationRequestId: "coop-req-1",
      senderUserId: "user-2",
      senderFirmId: "firm-2",
      messageBody: "Can your team confirm availability for an anonymised first review?",
      containsConfidentialDetails: false,
      createdAt: now - 2 * day,
      editedAt: null,
    },
    {
      id: "coop-msg-2",
      cooperationRequestId: "coop-req-2",
      senderUserId: "user-5",
      senderFirmId: "firm-5",
      messageBody: "Happy to give an initial public-law view. Please keep the first note high level.",
      containsConfidentialDetails: false,
      createdAt: now - day,
      editedAt: null,
    },
  ],
  cooperationRequestEvents: [
    { id: "coop-req-event-1", cooperationRequestId: "coop-req-1", eventType: "sent", actorUserId: "user-2", actorFirmId: "firm-2", createdAt: now - 2 * day, metadataJson: "{\"preview\":\"Local counsel request\"}" },
    { id: "coop-req-event-2", cooperationRequestId: "coop-req-1", eventType: "conflict_check_requested", actorUserId: "user-2", actorFirmId: "firm-2", createdAt: now - 2 * day + 60 * 60 * 1000 },
    { id: "coop-req-event-3", cooperationRequestId: "coop-req-2", eventType: "sent", actorUserId: "user-1", actorFirmId: "firm-1", createdAt: now - 3 * day },
    { id: "coop-req-event-4", cooperationRequestId: "coop-req-2", eventType: "accepted", actorUserId: "user-5", actorFirmId: "firm-5", createdAt: now - day },
    { id: "coop-req-event-5", cooperationRequestId: "coop-req-3", eventType: "sent", actorUserId: "user-1", actorFirmId: "firm-1", createdAt: now - day },
    { id: "coop-req-event-6", cooperationRequestId: "coop-req-3", eventType: "conflict_check_requested", actorUserId: "user-1", actorFirmId: "firm-1", createdAt: now - 2 * 60 * 60 * 1000 },
  ],
  conflictCheckRecords: [
    {
      id: "conflict-1",
      cooperationRequestId: "coop-req-1",
      requestedByUserId: "user-2",
      targetFirmId: "firm-1",
      status: "requested",
      conflictSummary: "Professional review requested. No detailed conflict information is required.",
      createdAt: now - 2 * day,
      updatedAt: now - 6 * 60 * 60 * 1000,
    },
    {
      id: "conflict-2",
      cooperationRequestId: "coop-req-3",
      requestedByUserId: "user-1",
      targetFirmId: "firm-7",
      status: "requested",
      conflictSummary: "Awaiting Spanish firm professional review.",
      createdAt: now - day,
      updatedAt: now - 2 * 60 * 60 * 1000,
    },
  ],
  cooperationOutcomes: [
    {
      id: "coop-outcome-1",
      cooperationRequestId: "coop-req-2",
      outcomeType: "cooperation_started",
      requesterRating: null,
      recipientRating: null,
      cooperationNotes: "Initial non-confidential view accepted.",
      createdAt: now - day,
      metadataJson: "{\"governanceImpact\":false}",
    },
  ],
  notifications: [
    { id: "not-1", userId: "user-1", firmId: "firm-1", type: "view requested", title: "Your view is requested", body: "Van Dijk Legal asked for member views on green claims guidance.", targetType: "discussion", targetId: "disc-1", readAt: null, createdAt: now - 3 * 60 * 60 * 1000 },
    { id: "not-2", userId: "user-1", firmId: "firm-1", type: "cooperation confirmation", title: "Cooperation confirmation", body: "A standard cooperation item is awaiting professional review.", targetType: "cooperationEvent", targetId: "coop-1", readAt: null, createdAt: now - day },
    { id: "not-3", userId: "user-1", firmId: "firm-1", type: "cooperation request received", title: "Cooperation request received", body: "A member sent a local counsel request. Open the request for details.", targetType: "cooperationRequest", targetId: "coop-req-1", readAt: null, createdAt: now - 6 * 60 * 60 * 1000 },
  ],
  activityEvents: [
    { id: "act-1", actorUserId: "user-2", actorFirmId: "firm-2", type: "discussion created", title: "Green claims guidance", summary: "A question was opened for member views.", targetType: "discussion", targetId: "disc-1", practiceAreaIds: ["pa-3", "pa-8"], visibility: "network", createdAt: now - 2 * day },
    { id: "act-2", actorUserId: "user-5", actorFirmId: "firm-5", type: "legislation file added", title: "Digital Fairness consultation", summary: "A legislative tracker item was added.", targetType: "legislationFile", targetId: "leg-1", practiceAreaIds: ["pa-3", "pa-8"], visibility: "members", createdAt: now - 8 * day },
    { id: "act-3", actorUserId: "user-3", actorFirmId: "firm-3", type: "vote opened", title: "Drafting lead rotation", summary: "A governance proposal is in its amendment window.", targetType: "governanceProposal", targetId: "prop-1", practiceAreaIds: ["pa-8"], visibility: "members", createdAt: now - day },
  ],
  savedItems: [
    { id: "saved-1", userId: "user-1", itemType: "legislationFile", itemId: "leg-1", createdAt: now - 7 * day, updatedAt: now - day },
    { id: "saved-2", userId: "user-1", itemType: "discussion", itemId: "disc-1", createdAt: now - 2 * day, updatedAt: now - 3 * 60 * 60 * 1000 },
    { id: "saved-3", userId: "user-1", itemType: "governanceProposal", itemId: "prop-1", createdAt: now - day, updatedAt: now - day },
    { id: "saved-4", userId: "user-1", itemType: "topic", itemId: "AI regulation", createdAt: now - 12 * 60 * 60 * 1000, updatedAt: now - 12 * 60 * 60 * 1000 },
  ],
  hiddenRecommendations: [],
  quickAccessPins: [],
  myFiles: {
    toReview: [
      { id: "mf-1", label: "Requested view", detail: "Green claims guidance", action: "Share a note", target: "/discussions", kind: "view" },
      { id: "mf-2", label: "Professional responsibility notice", detail: "Luxembourg view on digital service notice timing", action: "Review", target: "/expertise-exchange", kind: "cooperation" },
    ],
    drafts: [{ id: "mf-3", label: "Draft joint position", detail: "Digital Fairness consultation", action: "Read joint position", target: "/legislation", kind: "draft" }],
    following: [{ id: "mf-4", label: "Watched legislative file", detail: "EU Digital Fairness consultation", action: "Watch legislative file", target: "/legislative-action", kind: "legislation" }],
    recent: [{ id: "mf-5", label: "Governance proposal", detail: "Rotate drafting leads", action: "Review and vote", target: "/discussions", kind: "vote" }],
  },
};
